
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import schedaSpeseService from './schedaSpeseService';

export const DEFAULT_SCHEDA_LIMIT = 3;

const initialState = {
  schedaSpese: [],
  singleSchedaSpeseGet: null,
  activeTab: 'shared',
  isError: false,
  isSuccess: false,
  isLoading: false,
  isLoadingMore: false,
  hasMore: false,
  total: 0,
  message: '',
  searchResults: [],
  isSearching: false,

};

// Get schedaSpese
export const singleSchedaSpeseGet = createAsyncThunk(
  'singleSchedaSpese/get',
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await schedaSpeseService.singleSchedaSpeseGet(data, token);
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get schedaSpese
export const getSchedaSpese = createAsyncThunk(
  'schedaSpese/get',
  async (_, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await schedaSpeseService.getSchedaSpese(token);
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Create a new SchedaSpese
export const createSchedaSpese = createAsyncThunk(
  'schedaSpese/create',
  async (schedaSpeseData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      const createdScheda = await schedaSpeseService.createSchedaSpese(schedaSpeseData, token);
      const { activeTab, schedaSpese } = thunkAPI.getState().schedaSpese;
      const refreshLimit = Math.max(schedaSpese.length + 1, DEFAULT_SCHEDA_LIMIT);
      if (activeTab === 'personal') {
        await thunkAPI.dispatch(getPersonalSchedaSpese({ limit: refreshLimit })).unwrap();
      } else {
        await thunkAPI.dispatch(getSharedSchedaSpese({ limit: refreshLimit })).unwrap();
      }
      return createdScheda;
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateSchedaSpese = createAsyncThunk(
  'schedaSpese/update',
  async (data, thunkAPI) => {
    console.log(data, "-------------schedaSpeseschedaSpese----------"); // Debugging
    try {
      const state = thunkAPI.getState();
      const token = state.auth.user.token;
      const schedaId = data.schedaId;
      // Extract the new nota's ID from the response
      const updatePayload = {}
      if(data.notaSpeseData) updatePayload.notaSpese = data.notaSpeseData._id ;
      if(data.titolo) updatePayload.titolo = data.titolo;
      if(data.utentiList) {
        updatePayload.titolo = data.titolo
        updatePayload.utentiList = data.utentiList;
      }
      if(data.removedEmails) {
        updatePayload.titolo = data.titolo
        updatePayload.removedEmails = data.removedEmails;
      }
      if(data.roleUpdates) {
        updatePayload.titolo = data.titolo
        updatePayload.roleUpdates = data.roleUpdates;
      }
      // Build the payload to push the new notaSpese ID into the array
      // const updatePayload = {
      //   notaSpese: newNotaSpeseId,
      //   titolo: data.titolo,
      //  };

      const updatedScheda = await schedaSpeseService.updateSchedaSpese(schedaId, updatePayload, token);
      const { activeTab, schedaSpese } = thunkAPI.getState().schedaSpese;
      const refreshLimit = Math.max(schedaSpese.length, DEFAULT_SCHEDA_LIMIT);
      if (activeTab === 'personal') {
        await thunkAPI.dispatch(getPersonalSchedaSpese({ limit: refreshLimit })).unwrap();
      } else {
        await thunkAPI.dispatch(getSharedSchedaSpese({ limit: refreshLimit })).unwrap();
      }
      return updatedScheda;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Delete SchedaSpese
export const deleteSchedaSpese = createAsyncThunk(
  'schedaSpese/delete',
  async (schedaId, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      const deletedScheda = await schedaSpeseService.deleteSchedaSpese(schedaId, token);
      const { activeTab, schedaSpese } = thunkAPI.getState().schedaSpese;
      const refreshLimit = Math.max(schedaSpese.length, DEFAULT_SCHEDA_LIMIT);
      if (activeTab === 'personal') {
        await thunkAPI.dispatch(getPersonalSchedaSpese({ limit: refreshLimit })).unwrap();
      } else {
        await thunkAPI.dispatch(getSharedSchedaSpese({ limit: refreshLimit })).unwrap();
      }
      return deletedScheda;
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get only personal schedaSpese. Pass { skip, limit, append } to page through the
// list; append:true keeps the already-loaded schede and adds the new page after them.
export const getPersonalSchedaSpese = createAsyncThunk(
  'schedaSpese/getPersonal',
  async ({ skip = 0, limit = DEFAULT_SCHEDA_LIMIT, append = false } = {}, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      const response = await schedaSpeseService.getPersonalSchedaSpese(token, { skip, limit });
      return { ...response, append };
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get only shared schedaSpese. Pass { skip, limit, append } to page through the
// list; append:true keeps the already-loaded schede and adds the new page after them.
export const getSharedSchedaSpese = createAsyncThunk(
  'schedaSpese/getShared',
  async ({ skip = 0, limit = DEFAULT_SCHEDA_LIMIT, append = false } = {}, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      const response = await schedaSpeseService.getSharedSchedaSpese(token, { skip, limit });
      return { ...response, append };
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Search schede by titolo (min 3 chars, enforced server-side too).
export const searchSchedaSpese = createAsyncThunk(
  'schedaSpese/search',
  async (q, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await schedaSpeseService.searchSchedaSpese(q, token);
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Fetch the next page for whichever tab is active, appending to the current list.
export const loadMoreSchedaSpese = createAsyncThunk(
  'schedaSpese/loadMore',
  async (_, thunkAPI) => {
    const { activeTab, schedaSpese } = thunkAPI.getState().schedaSpese;
    const params = { skip: schedaSpese.length, limit: DEFAULT_SCHEDA_LIMIT, append: true };
    const action = activeTab === 'personal' ? getPersonalSchedaSpese : getSharedSchedaSpese;
    return thunkAPI.dispatch(action(params)).unwrap();
  }
);

// Hide a shared scheda from my own list (optionally notify the owner)
export const hideSchedaSpese = createAsyncThunk(
  'schedaSpese/hide',
  async ({ id, notifyOwner }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      const result = await schedaSpeseService.hideSchedaSpese({ id, notifyOwner }, token);
      const refreshLimit = Math.max(thunkAPI.getState().schedaSpese.schedaSpese.length, DEFAULT_SCHEDA_LIMIT);
      await thunkAPI.dispatch(getSharedSchedaSpese({ limit: refreshLimit })).unwrap();
      return result;
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Restore a scheda previously hidden from my own list
export const unhideSchedaSpese = createAsyncThunk(
  'schedaSpese/unhide',
  async (id, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      const result = await schedaSpeseService.unhideSchedaSpese(id, token);
      const refreshLimit = Math.max(thunkAPI.getState().schedaSpese.schedaSpese.length, DEFAULT_SCHEDA_LIMIT);
      await thunkAPI.dispatch(getSharedSchedaSpese({ limit: refreshLimit })).unwrap();
      return result;
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



const schedaSpeseSlice = createSlice({
  name: 'schedaSpese',
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    clearSearchResults: (state) => {
      state.searchResults = [];
      state.isSearching = false;
    },
    reset: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSchedaSpese.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createSchedaSpese.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // state.schedaSpese.unshift(action.payload); // da rivedere forse meglio fare la get dopo la post 
      })
      .addCase(createSchedaSpese.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateSchedaSpese.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSchedaSpese.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // const index = state.schedaSpese.findIndex((scheda) => scheda._id === action.payload._id);
        // console.log(action.payload, '--------------action.payload'); // Debugging
        // if (index !== -1) {
        //   state.schedaSpese[index] = action.payload;
        // }
      })
      .addCase(updateSchedaSpese.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getSchedaSpese.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSchedaSpese.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.schedaSpese = action.payload;
        state.isError = false;
        state.message = '';
      })
      .addCase(getSchedaSpese.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || 'Failed to fetch expense records';
        state.schedaSpese = []; 
      })
      .addCase(deleteSchedaSpese.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteSchedaSpese.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // Remove the deleted scheda from the array
        // state.schedaSpese = state.schedaSpese.filter(
        //   (scheda) => scheda._id !== action.payload.id
        // );
      })
      .addCase(deleteSchedaSpese.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(singleSchedaSpeseGet.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(singleSchedaSpeseGet.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.singleSchedaSpese = action.payload;
        state.isError = false;
        state.message = '';
      })
      .addCase(singleSchedaSpeseGet.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || 'Failed to fetch single expense record';
        state.singleSchedaSpese = null; // Reset singleSchedaSpese on error
      })
      // Handle getPersonalSchedaSpese
      .addCase(getPersonalSchedaSpese.pending, (state, action) => {
        if (action.meta.arg?.append) {
          state.isLoadingMore = true;
        } else {
          state.isLoading = true;
        }
      })
      .addCase(getPersonalSchedaSpese.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoadingMore = false;
        state.isSuccess = true;
        const { items, total, hasMore, append } = action.payload;
        state.schedaSpese = append ? [...state.schedaSpese, ...items] : items;
        state.total = total;
        state.hasMore = hasMore;
        state.isError = false;
        state.message = '';
      })
      .addCase(getPersonalSchedaSpese.rejected, (state, action) => {
        state.isLoading = false;
        state.isLoadingMore = false;
        state.isError = true;
        state.message = action.payload || 'Failed to fetch personal expense records';
        if (!action.meta.arg?.append) state.schedaSpese = [];
      })
      // Handle getSharedSchedaSpese
      .addCase(getSharedSchedaSpese.pending, (state, action) => {
        if (action.meta.arg?.append) {
          state.isLoadingMore = true;
        } else {
          state.isLoading = true;
        }
      })
      .addCase(getSharedSchedaSpese.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoadingMore = false;
        state.isSuccess = true;
        const { items, total, hasMore, append } = action.payload;
        state.schedaSpese = append ? [...state.schedaSpese, ...items] : items;
        state.total = total;
        state.hasMore = hasMore;
        state.isError = false;
        state.message = '';
      })
      .addCase(getSharedSchedaSpese.rejected, (state, action) => {
        state.isLoading = false;
        state.isLoadingMore = false;
        state.isError = true;
        state.message = action.payload || 'Failed to fetch shared expense records';
        if (!action.meta.arg?.append) state.schedaSpese = [];
      })
      // Handle searchSchedaSpese
      .addCase(searchSchedaSpese.pending, (state) => {
        state.isSearching = true;
      })
      .addCase(searchSchedaSpese.fulfilled, (state, action) => {
        state.isSearching = false;
        state.searchResults = action.payload;
      })
      .addCase(searchSchedaSpese.rejected, (state, action) => {
        state.isSearching = false;
        state.searchResults = [];
      });
  },
});

export const { reset, setActiveTab, clearSearchResults } = schedaSpeseSlice.actions;
export default schedaSpeseSlice.reducer;



// export const updateEvent = createAsyncThunk(
//   'match/update',
//   async (data, thunkAPI) => {
//     try {
//       const state = thunkAPI.getState();
//       const token = state.auth.user.token;
//       const eventId = data.matchId; // Assuming you pass the eventId as part of the data parameter
//       const matchData = {
//         ...data.matchData, // Assuming you pass other event data fields in eventData
//       };

//       return await budgetService.updateEvent(eventId, matchData, token);
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );
